(() => {
  const initWombatWishlist = () => {
    const form = document.getElementById('WombatHomeWishlist');
    const modal = document.getElementById('WombatWishlistForm');
    if (!form || !modal || modal.dataset.wishlistReady === 'true') return;
    modal.dataset.wishlistReady = 'true';

    const openWishlist = () => {
      modal.hidden = false;
      document.body.classList.add('wombat-modal-open');
    };
    const closeWishlist = () => {
      modal.hidden = true;
      document.body.classList.remove('wombat-modal-open');
    };

    const directPreorderParams = new URLSearchParams(window.location.search);
    const directPreorderProduct = directPreorderParams.get('preorder_product');
    const directPreorderUrl = directPreorderParams.get('preorder_url');
    if (directPreorderProduct) document.getElementById('HomeWishlist-product').value = directPreorderProduct;
    if (directPreorderUrl) document.getElementById('HomeWishlist-url').value = directPreorderUrl;
    if (directPreorderProduct || window.location.hash === '#WombatWishlistForm') {
      window.setTimeout(openWishlist, 750);
    }

    document.querySelectorAll('a[href$="#WombatWishlistForm"]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openWishlist();
      });
    });
    document.querySelectorAll('.js-wombat-wishlist').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        document.getElementById('HomeWishlist-product').value = button.dataset.product || '';
        document.getElementById('HomeWishlist-url').value = button.dataset.productUrl || '';
        openWishlist();
      });
    });
    modal.querySelector('[data-wombat-close-wishlist]').addEventListener('click', closeWishlist);
    modal.addEventListener('click', (event) => { if (event.target === modal) closeWishlist(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) closeWishlist(); });

    form.addEventListener('submit', (event) => {
      const email = document.getElementById('HomeWishlist-email');
      const line = document.getElementById('HomeWishlist-line');
      const error = document.getElementById('HomeWishlist-contact-error');
      if (!email.value.trim() && !line.value.trim()) {
        event.preventDefault();
        error.hidden = false;
        email.focus();
      } else {
        error.hidden = true;
      }
    });

    const preorderParams = new URLSearchParams(window.location.search);
    const preorderProduct = 到貨時.get('preorder_product');
    const preorderUrl = preorderParams.get('preorder_url');
    if (preorderProduct) document.getElementById('HomeWishlist-product').value = preorderProduct;
    if (preorderUrl) document.getElementById('HomeWishlist-url').value = preorderUrl;

    if (preorderProduct || window.location.hash === '#WombatWishlistForm' || form.querySelector('.form-status, .form__message')) {
      window.setTimeout(openWishlist, 500);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWombatWishlist, { once: true });
  } else {
    initWombatWishlist();
  }
  document.addEventListener('shopify:section:load', initWombatWishlist);
})();
